export default "__VITE_ASSET__3ba95460__"